<template>
	<div class="container page-container">

		<h1>Your Projects</h1>

		<div class="add-project" v-if="user.isAdmin">
			<el-form :inline="true" :model="newProject" :rules="rules" ref="addProjectForm" :label-position="labelPosition" class="form-inline">
			  <el-form-item label="Project Name" prop="name">
			    <el-input v-model="newProject.name" placeholder="Name"></el-input>
			  </el-form-item>
			  <el-form-item label=" ">
			    <el-button class="btn-add" type="primary" @click="addproject('addProjectForm')">Add&nbsp;&nbsp;<i class="el-icon-plus el-icon-right"></i></el-button>
			  </el-form-item>
			</el-form>
		</div>

    <div v-if="user.isAdmin !== true">
        <el-row :gutter="10" v-if="auth.user !== null">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" v-for="(project, index) in userProjects" :key="project.name">
            <el-card class="box-card">
              <div class="text item">
                <span class="project-title">{{project.name}}</span>
                <el-button style="float: right;" @click.prevent="$router.push('/projects/' +project['.key'])">Manage</el-button> <!--  project.slug -->
                <span class="edited">Edited: {{prettyDate(project.edited)}}</span>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <br>
    </div>

    <div v-if="user.isAdmin == true">
      <el-row :gutter="10" v-if="auth.user !== null">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" v-for="(project, index) in projects" :key="project.name">
          <el-card class="box-card">
            <div class="text item">
              <span class="project-title">{{project.name}}</span>
              <el-button style="float: right;" @click.prevent="$router.push('/projects/' +project['.key'])">Manage</el-button> <!--  project.slug -->
              <span class="edited">Edited: {{prettyDate(project.edited)}}</span>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <br>
    </div>

    <!-- <el-button size="large" @click.prevent="$router.push('/users')" v-if="user.isAdmin">Manage Users</el-button> -->

	</div>
</template>
<script>
import { db, authService } from '../helpers/helpers'
import slugify from 'slugify'
import moment from 'moment'

let projectsRef = db.ref('projects')
let usersRef = db.ref('users')

export default {
  name: 'projects',
  firebase: {
    projects: projectsRef.orderByChild('mostRecent')
  },
  data () {
    return {
      admin: true,
      auth: authService,
      labelPosition: 'top',
      userInline: {
        displayName: '',
        email: '',
        password: ''
      },
      rules: {
        email: [
          { required: true, message: 'Please enter you email address', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }
        ],
        name: [
          { required: true, message: 'Project Name required', trigger: 'blur' }
        ]
      },
      newProject: {
        created: null,
        edited: null,
        slug: '',
        name: '',
        units: '',
        users: ''
      }
    }
  },
  methods: {
    addproject (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let timeStamp = Date.now()
          this.newProject.mostRecent = -Math.abs(timeStamp)
          this.newProject.created = timeStamp
          this.newProject.edited = timeStamp
          this.newProject.slug = slugify(this.newProject.name.toLowerCase())
          projectsRef.push(this.newProject)
          this.newProject.created = ''
          this.newProject.edited = ''
          this.newProject.slug = ''
          this.newProject.name = ''
          this.newProject.units = ''
        } else {
          console.log('Error with add project!')
          return false
        }
      })
    },
    prettyDate (date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a')
    }
  },
  created: function () {
    this.$bindAsObject('user', usersRef.child(this.auth.user.uid))
    this.$bindAsArray('userProjects', projectsRef.orderByChild('users/' + this.auth.user.uid).equalTo(true))
  }
}
</script>
<style>

  .page-container {
    padding-left:  15px;
    padding-right:  15px;
    padding-bottom:  60px;
  }

  .el-col {
    border-radius: 4px;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .box-card {
    margin-bottom:  15px;
  }

  .project-title {
    line-height:  22px;
    font-size:  22px;
    display:  inline-block;
    margin-bottom:  10px;
    font-weight:  600;
  }

  .edited {
    display:  block;
    font-size:  10px;
  }

  .btn-add {
    margin-top: 5px;
  }

</style>


// WEBPACK FOOTER //
// Projects.vue?8fd83e30